import React from 'react'
import Activities from '../../../../../../modules/Activities';
import Diary from '../../../../../../modules/Diary';
import CurrentTemperature from './components/CurrentTemperature';
import { isEmpty } from 'ramda';

const Health = ({ cowid, health }) => {
    return (
        !isEmpty(health) && (
            <>
                {health.current && <CurrentTemperature current={health.current} />}
                {health.activities && <Activities activities={health.activities} calendar={health.calendar} />}
                {health.diary && <Diary id={cowid} endpointDiary='/rpc/get_cow_health_alerts' endpointNote='' diary={health.diary} disableAddNote/>}
            </>
        )
    )
}

export default Health